var exports = {
  "$7": "overflowing__IQ3Haq",
  "sz": "expanded__913ls9",
  "Qs": "content__LWjQvP",
  "L$": "toggle__HK5fpT",
};

module.exports = exports;
